import { mapActions, mapGetters } from 'vuex'

const emptyForm = () => ({
  totalModules: 0,
  completedModules: 0,
  totalMaterials: 0,
  completedMaterials: 0,
  totalHours: 0,
  completedHours: 0,
  totalPoints: 0,
  completedPoints: 0,
})

export default {
  name: 'edit-progress-dialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    userCourse: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: emptyForm(),
    }
  },
  computed: {
    ...mapGetters({
      progressSnapshot: 'userCertificate/progressSnapshot',
      progressSnapshotAudits: 'userCertificate/progressSnapshotAudits',
      isProgressSnapshotLoading: 'userCertificate/isProgressSnapshotLoading',
      isProgressSnapshotSaving: 'userCertificate/isProgressSnapshotSaving',
    }),
    dialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  watch: {
    value(open) {
      if (open && this.userCourse) {
        this.loadSnapshot()
      }
    },
    progressSnapshot(snapshot) {
      if (!snapshot) {
        return
      }

      this.form = {
        totalModules: snapshot.totalModules,
        completedModules: snapshot.completedModules,
        totalMaterials: snapshot.totalMaterials,
        completedMaterials: snapshot.completedMaterials,
        totalHours: Math.round(snapshot.totalMinutes / 60),
        completedHours: Math.round(snapshot.completedMinutes / 60),
        totalPoints: this.pointsFromInternal(snapshot.totalPoints),
        completedPoints: this.pointsFromInternal(snapshot.completedPoints),
      }
    },
  },
  methods: {
    ...mapActions({
      getProgressSnapshot: 'userCertificate/GET_PROGRESS_SNAPSHOT',
      updateProgressSnapshot: 'userCertificate/UPDATE_PROGRESS_SNAPSHOT',
      getProgressAudits: 'userCertificate/GET_PROGRESS_AUDITS',
    }),
    pointsFromInternal(value) {
      return Number((value / 100).toFixed(2))
    },
    pointsToInternal(value) {
      return Math.round(Number(value) * 100)
    },
    payload() {
      return {
        courseId: this.userCourse.courseId,
        userId: this.userCourse.userId,
        userCertificateId: this.userCourse.userCertificate.data.id,
      }
    },
    loadSnapshot() {
      const base = this.payload()

      this.getProgressSnapshot(base).catch(() => {
        this.$toasted.error('Progress snapshot not found')
        this.close()
      })

      this.getProgressAudits(base)
    },
    formatAuditChange(audit) {
      const keys = [
        'completed_modules',
        'completed_materials',
        'completed_minutes',
        'completed_points',
      ]

      return keys
        .filter(key => audit.before[key] !== audit.after[key])
        .map(key => `${key}: ${audit.before[key]} → ${audit.after[key]}`)
        .join('; ')
    },
    save() {
      this.updateProgressSnapshot({
        ...this.payload(),
        form: {
          total_modules: this.form.totalModules,
          completed_modules: this.form.completedModules,
          total_materials: this.form.totalMaterials,
          completed_materials: this.form.completedMaterials,
          total_minutes: this.form.totalHours * 60,
          completed_minutes: this.form.completedHours * 60,
          total_points: this.pointsToInternal(this.form.totalPoints),
          completed_points: this.pointsToInternal(this.form.completedPoints),
        },
      }).then(() => {
        this.$toasted.success('Progress snapshot saved')
        this.$emit('saved')
        this.close()
      }).catch(() => {
        this.$toasted.error('Failed to save progress snapshot')
      })
    },
    close() {
      this.dialog = false
      this.form = emptyForm()
    },
  },
}
